	import { Component, ViewChild } from '@angular/core';
	import { WorkflowService } from './workflow.service';
	import { ConstraintsModel, dateConstraints, dateMatchModes, GridColumnHeader, MatchModeOptionsModel, textNumberConstraints, textNumberMatchModes } from '../../models/grid-column-header';
	import { UserSystemPreference } from '../../models/userSystemPreference';
	import { WorkItem } from '../../models/work-item';
	import { CommonService } from '../../services/common.service';
	import { SaveColumnsReorder } from '../../models/save-Columns-Reorder';
	import { Table } from 'primeng/table';
	import * as XLSX from 'xlsx';
	import { GPID } from '../../models/GPID';
	import { GlobalService } from '../../services/global.service';
	import { MatDialog } from '@angular/material/dialog';
	import { UserReassignComponent } from '../../shared/user-reassign/user-reassign.component';
	import { ReAssignReleaseDto } from '../../models/reAssignReleaseDto';
	import { ActivateSuspendDto } from '../../models/activateSuspendDto';
	import { DeleteWorkItemDto } from '../../models/deleteWorkItemDto';
	import { DialogComponent, DialogData } from '../../shared/dialog/dialog.component';
	import { WorkflowHistoryResponse } from '../../models/workflow-history.model';
	import { WorkflowHistoryDialogComponent } from '../../shared/workflow-history-dialog/workflow-history-dialog.component';
	import { RetrievalService } from '../retrieval/retrieval.service';
	import { DocumentHistoryResponse } from '../../models/document-history.model';
	import { DocumentHistoryDialogComponent } from '../../shared/document-history-dialog/document-history-dialog.component';
	import { ViewAddDocNotesComponent } from '../../shared/view-add-doc-notes/view-add-doc-notes.component';
	import { ViewWorkflowNotesComponent } from '../../shared/view-workflow-notes/view-workflow-notes.component';
	import { UserWorkflowQueue, Workflow, WorkflowQueueStatus } from '../../models/workflow.models';
	import { AppContext } from '../../models/appContext';
	import { LineItemsGlEntryComponent } from '../../shared/line-items-gl-entry/line-items-gl-entry.component';
	import { environment } from '../../../environments/environment';
	import { DateService } from '../../services/date.service';

	@Component({
	  selector: 'app-workflow',
	  templateUrl: './workflow.component.html',
	  styleUrl: './workflow.component.scss'
	})
	export class WorkflowComponent {
	  error = false;
	  isCount: boolean = false;
	  adminEmitter: any = {
		alter: 'alter',
		reAssign: 're-assign',
		releaseStatus: 'The selected work Item is already Released',
		apiCallSuccess: 'Changes has been Updated',
		Suspend: 'Suspend',
		Active: 'Active',
	  };
	  adminQueueDetails!: UserWorkflowQueue[];
	  isDropDownVisible = false;
	  gpidItems = '';
	  adminTreeQueueId: number = 0;
	  activeQueueIndex: number = -1;
	  selectedAdminWorkFlowId: number = 0;
	  AdminTreeWorkFlowData: any;
	  isWorkStatusActive: boolean = false; 
	  rowsOptions = [ 
		{ label: '25', value: 25 },
		{ label: '50', value: 50 },
		{ label: '75', value: 75 },
		{ label: '100', value: 100 },
		{ label: '200', value: 200 },
		{ label: '300', value: 300 },
		{ label: '500', value: 500 },
		{ label: 'All', value: 0 },
	  ];
	  rows: number = 25;
	  selectedMaxItem: number = 0;
	  dragSelecting = false;
	  selectedIndexes: number[] = []; 
	  totalCount: any;
	  activeCount: any;
	  suspendedCount: any;
	  workFlowNil: boolean = false;
	  assignedCount: any;
	  unassignedCount: any;

	  public gridData!: any[];
	  public pageSize = 10;
	  public skip = 0;
	  public columnHeaderArray: GridColumnHeader[] = [];
	  public selectedSystemId: any | undefined;
	  userSystemPreferencedata!: UserSystemPreference[];
	  public selectedDateFormat!: string | null;
	  public datePreferenceEnglish: boolean = false;
	  public datePreferenceRussian: boolean = false;
	  public datePreference!: string | null;
	  public savedGridColumnOptions!: GridColumnHeader[];
	  public workItems: WorkItem[] = [];
	  public data: WorkItem[] = [];
	  public columns: GridColumnHeader[] = [];
	  public selectedWorkItems: WorkItem[] = [];
	  public dateformat!: string;
	  public isDataAvailable: boolean = false;
	  public saveColumnReorderDto: any;
	  public gridOption: any;
	  isloading: boolean = false;
	  isTableVisible: boolean = false;
	  isWorkItems: boolean = false;
	  isAutoAssignVisible: boolean = false;
	  event: Event | undefined;
	  gpids: GPID[] = [];
	  gpIdsAlter: GPID[] = [];
	  gpidPreference: boolean = false;
	  isDropDownLoading: boolean = false;
	  isDocumentNotesDisable: boolean = true;
	  isWorkflowNotesDisable: boolean = true;
	  isDocumentHistoryDisable: boolean = true;
	  isWorkflowHistoryDisable: boolean = true;
	  isAutoAssignDisable: boolean = true;
	  isSuspendDisable: boolean = true;
	  isAlterDisable: boolean = true;
	  isDeleteDisable: boolean = true;
	  isActivateDisable: boolean = true;
	  isReAssignDisable: boolean = true;
	  isReleaseDisable: boolean = true;
	  isRefreshWorkItemDisable: boolean = true;
	  isExportToExcelDisable: boolean = true;
	  isSelectedDocumentsDisable: boolean = true;
	  isTableLoading: boolean = true;
	  isQueueTreeLoading: boolean = true;
	  isQueueStatusLoading: boolean = false;
	  adminTreeWorkFlowDetails!: Workflow[];
	  expandedPanelId: number | null = null;
	  leftQueuePanelOpen = true;
	  @ViewChild('workflowGrid') table!: Table;
	  private readonly boundStorageListener = this.onStorageEvent.bind(this);
	  private intervalId?: number;
	  routedWorkItem: WorkItem | null = null;
	  sortField: string = '';
	  sortOrder: number = 1;
	  // Filtering 1 for ascending, -1 for descending
	  filters: { [key: string]: any } = {};
	  userPreferedDateformat!:string |null;
	  userPreferedDateTimeformat!:string |null;
	  constructor(
		private readonly workflowService: WorkflowService,
		private readonly commonService: CommonService,
		private readonly globalVariable: GlobalService,
		private readonly retrievalService: RetrievalService,
		private readonly dialog: MatDialog,
		private readonly dateService:DateService
	  ) { }

	  async ngOnInit() {
		this.commonService.clearMessage();
		AppContext.userDetails = this.globalVariable.getUserDetails;
		window.addEventListener('storage', this.boundStorageListener);
		this.intervalId = window.setInterval(() => this.checkWorkItemUpdate(), 1000);
		await this.callRegisterPrincipal(Number(this.globalVariable.getSelectedSystemId));
		this.getUserPreferences();
		this.adminTreeGetWorkflows();
	  }

	  ngOnDestroy() {
		window.removeEventListener('storage', this.boundStorageListener);
		if (this.intervalId) {
		  clearInterval(this.intervalId);
		}
	  }

	  callRegisterPrincipal(systemId: number): Promise<void> {
		return new Promise((resolve, reject) => {
		  this.commonService.callRegisterPrincipal(systemId).subscribe({
			next: (response) => {
			  resolve();
			},
			error: (error) => {
			  this.commonService.openErrorDialog(error.error.message);
			  this.commonService.showMessage('User registration failed', 'error');
			  reject(error);
			}
		  });
		});
	  }

	  togglePanel(id: number | null) {
		if (this.expandedPanelId !== id) {
		this.expandedPanelId = id; // expand this panel and collapse others
		}
	  }

	  adminTreeGetWorkflows(isRefresh: boolean = false): void {
		this.isQueueTreeLoading = true;
		this.workflowService.getAdminTreeWorkFlowData().subscribe({
		  next: (response) => {
			this.adminTreeWorkFlowDetails = response;
			this.adminQueueDetails = this.adminTreeWorkFlowDetails[0].userWorkflowQueues;
			this.isQueueTreeLoading = false;
			this.workFlowNil = true;
			if (this.adminTreeWorkFlowDetails.length > 0) {
			  this.expandedPanelId = this.globalVariable.getWFSelectedWorkFlowId == 0 ?
			  this.adminTreeWorkFlowDetails[0].id: this.globalVariable.getWFSelectedWorkFlowId;
			  this.workFlowNil = false;
			  if (isRefresh) {
				this.getAdminQueues(this.globalVariable.getWFSelectedQueueId, this.globalVariable.getWFSelectedWorkFlowId, isRefresh);
			  } else {
				this.getAdminQueues(0, this.adminTreeWorkFlowDetails[0].userWorkflowQueues[0].workflowId);
			  }
			}
		  },
		  error: (_error) => {
			this.isQueueTreeLoading = true;
		  },
		});
	  }

	  getAdminQueues(queueId: number, ItemId: number, refresh: boolean = false) {
		this.error = false;
		this.adminQueueDetails = [];
		this.isDropDownVisible = false;
		this.gpidItems = '';
		this.isQueueTreeLoading = true;
		if (this.selectedAdminWorkFlowId != ItemId) {
		  this.selectedAdminWorkFlowId = ItemId;
		} 
		if (this.activeQueueIndex != queueId) {
		  this.activeQueueIndex = queueId;
		}
		if (refresh) {
		  this.getAdminQueueWorkItemsDetails(ItemId, queueId);
		  this.isQueuesSet(queueId);
		}
		this.isQueueTreeLoading = false;
	  }

	  getAdminQueueWorkItemsDetails(workflowId: number, queueId: number): void {
		this.isRefreshWorkItemDisable = false;
		this.isExportToExcelDisable = false;
		this.getAdminQueueDetails(workflowId, queueId);
		if (this.selectedAdminWorkFlowId != workflowId) {
		  this.selectedAdminWorkFlowId = workflowId; 
		}
		setTimeout(() => {
		  console.log('Finished loading queue details');
		}, 1000);
	  }

	  // Used to toggle button CSS class
	  isQueuesSet(id: number): boolean {
		return id == this.activeQueueIndex;
	  }

	  // Disable button if count is null, undefined, or 0
	  isICountNull(count: number | null | undefined): boolean {
		return !count || count == 0;
	  }

	  generateFilters(queueId: number) {
  this.columns.forEach((column) => {
    const currentFilter = this.filters[column.field];
    if (column.type == 'date') {
      column.filterOptions = [
        { label: 'Past 7 days', value: '7' },
        { label: 'Past 14 days', value: '14' },
        { label: 'Past 1 month', value: '30' },
        { label: 'Past 2 months', value: '60' },
        { label: 'Past 3 months', value: '90' },
        { label: 'Past 6 months', value: '182' },
        { label: 'Last year', value: '365' },
        { label: 'All', value: 'All' },
      ];
    } else {
      const values = new Set<string>();
      this.data.forEach((record) => {
        const propertyName: keyof WorkItem = column.field as keyof WorkItem;
        values.add(record[propertyName]);
      });
      column.filterOptions = Array.from(values).map((v) => ({
        label: v,
        value: v,
      }));
    }
      if (this.activeQueueIndex == queueId) {
        //Reassign previous selection if it exists
      if (Object.keys(this.filters).length === 0) {
          // filters is empty
        column.selectedValues = [];
      } else if (currentFilter) {
        this.filters[column.field] = currentFilter;
      }
    }
  });
}

	  getUserPreferences(): void {
		this.commonService.getUserPerferences().subscribe({
		  next: (response: UserSystemPreference[]) => {
			this.userSystemPreferencedata = response;
			this.globalVariable.setUserPreferences = response;
			this.userSystemPreferencedata.forEach((element) => {
			  if (element.preferenceTitle == 'Date Format Display') {
				this.selectedDateFormat = element.preferenceValue;
				this.userPreferedDateTimeformat = element.dateFormatOptions[0].defaultFormat;
				this.userPreferedDateformat = element.dateFormatOptions[0].defaultFormat.split(' ')[0];
				this.datePreferenceEnglish = this.selectedDateFormat == 'English';
				this.datePreferenceRussian = this.selectedDateFormat == 'Russian';
				this.datePreference = localStorage.getItem('setDatePreference');
				if (!this.datePreference) {
				  this.datePreference = 'English';
				}
				if (this.selectedSystemId == element.systemId) {
				  if (this.datePreference == element.preferenceValue) {
					element.dateFormatOptions.forEach((dateformatType) => {
					  if (dateformatType.language == this.datePreference) {
						this.dateformat = dateformatType.defaultFormat;
					  }
					});
				  }
				}
			  } else if (element.preferenceTitle == 'Routing in Workflow') {
				if (element.preferenceValue == 'true') {
				  localStorage.setItem('setUserPerferenceRoutingButton', 'button');
				} else {
				  localStorage.setItem('setUserPerferenceRoutingButton', 'select');
				}
			  }
			  else if (element.preferenceTitle == "WorkItem Count") {
				this.selectedMaxItem = Number(element.preferenceValue);
			  }
			});
		  },
		  error: (error) => {
			this.commonService.showMessage('Error in loading user preferences.','error');
		  },
		});
	  }

	  onStorageEvent(event: StorageEvent) {
		if (event.key === 'routedWorkItem') {
		  this.handleWorkItemUpdate();
		}
	  }

	  checkWorkItemUpdate() {
		const stored = localStorage.getItem('routedWorkItem');
		if (!stored) return;
		const parsed: WorkItem = JSON.parse(stored);
		if (!this.routedWorkItem || this.routedWorkItem.WorkflowId !== parsed.WorkflowId) {
		  this.handleWorkItemUpdate();
		}
	  }

	  handleWorkItemUpdate() {
		const stored = localStorage.getItem('routedWorkItem'); 
		if (!stored) return;
		this.routedWorkItem = JSON.parse(stored);
		if (this.routedWorkItem && this.adminQueueDetails && this.activeQueueIndex != null) {
		  this.refreshWorkItem();
		}
		localStorage.removeItem('routedWorkItem');
		this.routedWorkItem = null;
	  }

	  getGridColumnHeaders(workflowId: number, queueId: number): void {
		this.isTableLoading = true;
		this.commonService.getGridColumnHeaders(2, 0, queueId, workflowId, this.selectedSystemId)
		  .subscribe({
			next: (response) => {
			  this.columnHeaderArray = response.map((column)=>
				{
				let matchModeOptionslist: MatchModeOptionsModel[] = [];
				let constraintslist: ConstraintsModel[] = [];

				switch (column.type) {
					case 'string':
					case 'number':
					matchModeOptionslist = [...textNumberMatchModes];
					constraintslist = textNumberConstraints.map(c => ({ ...c }));
					break;
					case 'date':
					matchModeOptionslist = [...dateMatchModes];
					constraintslist = dateConstraints.map(c => ({ ...c }));
					break;
					default:
					matchModeOptionslist = [];
					constraintslist = [];
				}
				return {
					...column,
					advancefilter:  {
					matchModeOptions : matchModeOptionslist,
					operator: 'and',
					constraints: constraintslist,
					isAdvanceFilterUsed:false,
					}
				}
				});
			  this.columnHeaderArray.push({
				field: 'ddrLink',
				title: 'DDR Link',
				type: 'hyperlink',
				order: this.columnHeaderArray.length + 1,
				width: '120px',
				required: false,
				selectedValues: [],
				filterOptions: [],
				advancefilter: {
				  matchModeOptions: [],
				  operator: 'and',
				  constraints: [],
				  isAdvanceFilterUsed: false,
				}
			  });
			  [...this.columns].sort((a, b) => a.order - b.order);
			  this.columns = this.columnHeaderArray;
			  this.isDataAvailable = this.columns.length > 0 ? true : false;
			  this.getWorkItemsDetails(workflowId, queueId, this.selectedMaxItem);
			},
			error: (error) => {
			  this.isTableLoading = false;
			  this.isDataAvailable = false;
			},
		  });
	  }

	  getSelectedMaxWorkItems(): void {
		this.getWorkItemsDetails(this.selectedAdminWorkFlowId, this.activeQueueIndex, this.selectedMaxItem);//
	  }

	  getWorkItemsDetails(workflowId: number, queueId: number, maxCount: number): void {
		this.isTableLoading = true;
		this.workflowService.getWorkItemsDetails(workflowId, queueId, maxCount).subscribe({
		  next: (response) => {
			this.data = [];
			if (this.activeQueueIndex != queueId) { 
			  this.selectedWorkItems = [];
			  this.selectedIndexes = [0];
			  this.filters = {};
			  if (this.table?.clearFilterValues) {
				this.table.clearFilterValues();
			  }
			  this.activeQueueIndex = queueId; 
			}
			const results = response.workItems;
			const totalItems = results.length;
			this.isDataAvailable = totalItems > 0 ? true : false;
			const dataWorkItems =
			  response.workItems.length > 0
				? this.processWorkItemData(response.workItems)
				: response.workItems;
			this.data = dataWorkItems;
			this.workItems = dataWorkItems;
			if (totalItems > 0) {
			  this.error = false;
			  this.isCount = true;
			  this.isWorkItems = true;
			  this.isAutoAssignVisible = true;
			  this.isloading = true;
			  this.generateFilters(queueId);
			  this.customFilter();
			  this.isTableLoading = false;
			  this.syncSelectedWorkItems();
          if (this.activeQueueIndex == queueId) {
            //Reapply filters manually
            setTimeout(() => {
              Object.keys(this.filters).forEach(field => {
                const allFilterValues = this.columns.find(item => item.field == field)!.filterOptions.map(opt => opt.value);
                const value = this.filters[field];
                const isExists = value.some((val: any) => allFilterValues.includes(val));
                if (value && value.length > 0 && isExists) {
                  this.table.filter(value, field, 'in');
                }
                if (!isExists) {
                  delete this.filters[field];
                }
              });
            }); 
          }
			} else {
			  this.error = true;
			  this.isTableVisible = false;
			  this.isCount = false;
			  this.isWorkItems = false;
			  this.isTableLoading = false;
			}
		  },
		  error: (error) => {
			this.error = true;
			this.isloading = false;
			this.isTableVisible = false;
			this.isCount = false;
			this.isTableLoading = true;
		  },
		});
	  }

	  processWorkItemData(WorkItems: any): WorkItem[] {
		WorkItems.forEach((item: WorkItem) => {
		  item.view_Document = `/documentViewer/${item.QueueId}/${item.DocumentId}/${item.InstanceId}/002/${item.BatchId}`;
		  item.ddrLink = `${environment.siteUrl}/DDR/DirectDocumentRetrieval.html?sys_id=${this.globalVariable.getSelectedSystemId}&doc_id=${item.DocumentId}`;
		  for (const key in item) {
			if ( key.includes('DATE') || key === 'CreateDate' ) {
			  if(key == 'INVOICE_DATE'){
				item[key] = item[key] ? this.dateService.formatDateValue(item[key], this.userPreferedDateformat): '';
			  } else { 
				item[key] = item[key] ? this.dateService.formatDateValue(item[key], this.userPreferedDateTimeformat): '';
			  }
			}
		  }
		});
		return WorkItems;
	  }

	  getAdminQueueDetails(workflowId: number, queueId: number): void {
		this.isDropDownVisible = false;
		this.isQueueStatusLoading = true;
		this.gpidItems = '';
		this.selectedWorkItems = [];
		this.globalVariable.setWFSelectedWorkFlowId = workflowId;
		this.globalVariable.setWFSelectedQueueId = queueId;
		this.workflowService.getAdminQueueDetails(workflowId, queueId).subscribe({
		  next: (response: WorkflowQueueStatus) => {
			this.totalCount = response.totalCount;
			this.activeCount = response.active;
			this.suspendedCount = response.suspended;
			this.assignedCount = response.assigned;
			this.unassignedCount = response.unassigned;
			this.globalVariable.setWFSelectedWorkFlowId = workflowId;
			this.globalVariable.setWFSelectedQueueId = queueId;
			this.isQueueStatusLoading = false;
			this.getGridColumnHeaders(workflowId, queueId);
		  },
		  error: (error) => {
			this.isQueueStatusLoading = true;
		  },
		});
	  }

	  applyFilters(): void {
		if (JSON.stringify(this.filters) != '{}') {
		  Object.keys(this.filters).forEach((field) => {
			const selectedValues = this.filters[field];
			if (selectedValues && selectedValues.length > 0) {
			  const propertyName: keyof WorkItem = field as keyof WorkItem;
			  this.workItems = this.data.filter((workItem) =>
				selectedValues.includes(workItem[propertyName])
			  );
			}
		  });
		} else {
		  this.workItems = this.data;
		}
	  }

	  onRowsChange(event: Event) {
		this.selectedIndexes = [];
		this.syncSelectedWorkItems();
		const target = event.target as HTMLSelectElement;
		const selectedValue = Number(target.value);
		this.rows = selectedValue === 0 ? this.data.length : selectedValue;
	  }

	  isSelected(index: number): boolean {
		return this.selectedIndexes.includes(index);
	  }
	  
	  syncSelectedWorkItems() {
		this.selectedWorkItems = this.selectedIndexes
		  .filter(i => i >= 0 && i < this.workItems.length)
		  .map(i => this.workItems[i]); 
	  }

	  copyToClipboard(value: any) {
		if (value !== null && value !== undefined) {
		  navigator.clipboard.writeText(value.toString());
		  this.commonService.showMessage('Value copied to clipboard.', 'success');
		}
	  }

	  onRowClick(event: MouseEvent, index: number): void {
		this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
	  }

	  toggleRowSelection(index: number, ctrlKey: boolean, shiftKey: boolean) {
		if (!ctrlKey && !shiftKey) { 
		  this.selectedIndexes = [index];
		}
		else{
		  const alreadySelected = this.selectedIndexes.includes(index);
		  if (!alreadySelected) {
			this.selectedIndexes.push(index);
		  }
		  else {
			this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
		  }
		} 
		this.syncSelectedWorkItems();
	  }

	  onRowKeydown(event: KeyboardEvent, index: number): void {
	    if (event.key === 'Enter' || event.key === ' ') {
	      event.preventDefault();
	      this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
	    }
	  }

	  onMouseDown(event: MouseEvent,index: number) { 
		const ctrlKey = event.ctrlKey || event.metaKey;
		const shiftKey = event.shiftKey;
		if (event.button === 0 && !ctrlKey && !shiftKey) { 
		  this.dragSelecting = true;
		  this.selectedIndexes = [index];
		  this.syncSelectedWorkItems();
		  event.preventDefault();
		} 
	  }

	onMouseOver(event: MouseEvent, index: number) {
		if (event.button === 0 && this.dragSelecting && !this.selectedIndexes.includes(index)) {
		this.selectedIndexes.push(index);
		this.syncSelectedWorkItems();
		}
	}

	onMouseUp(event: MouseEvent) {
		if (this.dragSelecting) {
		this.dragSelecting = false; 
		} 
	}

	onRowFocus(_event: FocusEvent, _index: number): void {
	}

	customFilter(value?: any) {
		this.selectedIndexes = [];
		this.selectedWorkItems = [];
		this.syncSelectedWorkItems();
		let filteredData = [...this.data];
		if (Object.keys(this.filters).length) {
			Object.keys(this.filters).forEach((field) => {
				const selectedValues = this.filters[field];
				if (!selectedValues || selectedValues.length === 0)
					return;

				if (value === 'date') {
					if (selectedValues.includes('All'))
						return;

					const today = new Date();
					filteredData = filteredData.filter((workItem) => {
						const rawValue = workItem[field as keyof WorkItem];
						if (!rawValue)
							return false;

						const itemDate = this.parseCustomDate(rawValue);

						if (!itemDate)
							return false;

						if (isNaN(itemDate.getTime()))
							return false;

						return selectedValues.some((selectedRange: any) => {
							if (selectedRange === '365') {
								const start = new Date(today.getFullYear() - 1, 0, 1);
								const end = new Date(today.getFullYear(), 0, 1);
								return itemDate >= start && itemDate < end;
							}

							let filterDate = new Date(today);
							switch (selectedRange) {
								case '7':
									filterDate.setDate(today.getDate() - 7);
									break;
								case '14':
									filterDate.setDate(today.getDate() - 14);
									break;
								case '30':
									filterDate.setMonth(today.getMonth() - 1);
									break;
								case '60':
									filterDate.setMonth(today.getMonth() - 2);
									break;
								case '90':
									filterDate.setMonth(today.getMonth() - 3);
									break;
								case '182':
									filterDate.setMonth(today.getMonth() - 6);
									break;
								default:
									return false;
							}
							return itemDate >= filterDate;
						});
					});
				} else {
					const propertyName: keyof WorkItem = field as keyof WorkItem;
					filteredData = filteredData.filter((workItem) => selectedValues.includes(workItem[propertyName]));
				}
			});
		}
		this.workItems = filteredData;
	}

	parseCustomDate(dateString: string): Date | null {
		if (!dateString?.trim())
			return null;

		const [datePart, timePart] = dateString.trim().split(/\s+/);
		const format = this.userPreferedDateTimeformat;

		if (!format)
			return null;

		const dateSegments = datePart.split(/[-/]/).map(Number);
		if (dateSegments.length !== 3 || dateSegments.some(isNaN)) {
			return null;
		}

		let day: number, month: number, year: number;

		if (format.startsWith('dd/MM')) {
			[day, month, year] = dateSegments;
		} else if (format.startsWith('MM/dd')) {
			[month, day, year] = dateSegments;
		} else if (format.startsWith('yyyy/MM')) {
			[year, month, day] = dateSegments;
		} else {
			return null;
		}

		let hours = 0, minutes = 0, seconds = 0;

		if (timePart) {
			const t = timePart.split(':').map(Number);
			if (t.some(isNaN))
				return null;
			hours = t[0] ?? 0;
			minutes = t[1] ?? 0;
			seconds = t[2] ?? 0;
			if (hours > 23 || minutes > 59 || seconds > 59 || hours < 0 || minutes < 0 || seconds < 0) {
				return null;
			}
		}

		const date = new Date(year, month - 1, day, hours, minutes, seconds);
		return isNaN(date.getTime()) ? null : date;
	}  
  
	customClear(col: GridColumnHeader): void {
		if (col.advancefilter.isAdvanceFilterUsed) {
			this.clearCall(col);
		}
		this.filters[col.field] = [];
		if (this.table?.clearFilterValues) {
			this.table.clearFilterValues();
		}
		this.customFilter(col.field);
	}

  exportToExcel() {
	try {
      // Convert selected data to worksheet
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        this.data
      );

      // Create a new workbook and append the worksheet
	  const wb: XLSX.WorkBook = XLSX.utils.book_new();
	  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

	  // Generate Excel file
	  XLSX.writeFile(wb, 'selected-workitems.xlsx');
	  this.commonService.showMessage(
		'File downloaded successfully.',
		'success'
	  );
	} catch (error) {
	  this.commonService.showMessage(
		'Error while downloading excel file.',
		'error'
	  );
	}
  }

	  // Method to handle column reordering event
	  onColumnReordered(event: any) {
		let columnReordered: any[] = [];
		this.columns = this.columns.map((col, index) => ({
		  ...col,
		  Order: index + 1,
		}));
		this.columns.forEach((col) => {
		  columnReordered.push(col.title);
		});
		let reOderedDisplayname = columnReordered.join(' | ');
		this.saveColumnReorderDto = new SaveColumnsReorder();
		this.saveColumnReorderDto.userName = this.globalVariable.getUserGPID;
		this.saveColumnReorderDto.businessAreaId = 0;
		this.saveColumnReorderDto.fieldOrder = 0;
		this.saveColumnReorderDto.gridType = 2; // Workflow grid type
		this.saveColumnReorderDto.displayName = reOderedDisplayname;
		this.saveColumnReorderDto.wfQueueId = this.activeQueueIndex;
		this.saveColumnReorderDto.workFlowId = this.selectedAdminWorkFlowId;
		this.saveColumnReorderDto.systemId = Number(this.globalVariable.getSelectedSystemId);
		this.commonService.saveUserPreferencesColumns(this.saveColumnReorderDto, 0, this.globalVariable.getUserGPID, Number(this.globalVariable.getSelectedSystemId))
		  .subscribe({
			next: (response) => {
			  if (response) {
				this.commonService.showMessage('Saved reordered column for user ' + this.globalVariable.getUserGPID, 'success');
			  }
			},
			error: (error) => {
			  this.commonService.showMessage('Error: ' + error.error.message + ' - Unable to save reordered column for user ' + this.globalVariable.getUserGPID + '.','error');
			},
		  });
	  }

	  setDropDown(eventName: string, event: Event) {
		this.openUserSystemDialog(eventName);
	  }

	  refreshWorkItem() { 
		this.adminTreeGetWorkflows(true);
	  }

	  showLineItemsGLEntry(): void {
		if (!this.selectedWorkItems?.length) return;
		const dialogData = {
		  docId: this.selectedWorkItems[0].DocumentId,
		  abbyyDocId: this.selectedWorkItems[0].ABBYY_DOCUMENTID,
		  abbyyBatchId: this.selectedWorkItems[0].ABBYY_BATCHID,
		  isRetrieval: true,
		};
		this.dialog.open(LineItemsGlEntryComponent, {
		  width: '85%',
		  maxWidth: '100%',
		  height:'auto',
		  data: dialogData
		});
	  }

	  showViewNotes() {
		if (this.selectedWorkItems?.length != 1) return;
		const userGpid = this.globalVariable.getUserGPID;
		const systemId = this.globalVariable.getSelectedSystemId;
		const DOCID = this.selectedWorkItems[0].DocumentId;
		const items = this.selectedWorkItems[0].InstanceId;
		const BatchId = this.selectedWorkItems[0].BatchId;
		const dialogData = {
		  DocumentId: DOCID,
		  userGpid: userGpid,
		  systemId: systemId,
		  items: items,
		  BatchId: BatchId,
		  Type: 'viewandadd',
		};
		this.dialog.open(ViewWorkflowNotesComponent, {
		  width: '85%',
		  height: '600px',
		  maxWidth: '100%',
		  maxHeight: 'max-content',
		  data: dialogData,
		});
	  }

	  showDocumentNotesAdmin() {
		if (this.selectedWorkItems?.length != 1) return;
		const userGpid = this.globalVariable.getUserGPID;
		const systemId = this.globalVariable.getSelectedSystemId;
		const DOCID = this.selectedWorkItems[0].DocumentId;
		const dialogData = {
		  DocumentId: DOCID,
		  userGpid: userGpid,
		  systemId: systemId,
		  Type: 'view',
		};
		this.dialog.open(ViewAddDocNotesComponent, {
		  width: '85%',
		  maxWidth: '100%',
		  data: dialogData,
		});
	  }

	  showDocumentHistory() {
		if (this.selectedWorkItems.length != 1) {
		  return;
		}
		const userGpid = this.globalVariable.getUserGPID;
		const systemId = this.globalVariable.getSelectedSystemId;
		const documentId = this.selectedWorkItems[0].DocumentId;
		this.retrievalService.getDocumentHistory(userGpid, systemId, documentId)
		.subscribe({
		  next: (response: DocumentHistoryResponse) => {
			const dialogData = {
			  documentId: documentId,
			  batchId: response.batchId,
			  createDate: response.createDate,
			  docHistoryDtoList: response.docHistoryDtoList || [],
			};
			this.dialog.open(DocumentHistoryDialogComponent, {
			  width: '85%',
			  height: '1060px',
			  maxWidth: '100%',
			  maxHeight: 'max-content',
			  data: dialogData,
			});
		  },
		  error: (error) => {
			console.error('Not able to fetch the document history:', error);
		  },
		});
	  }

	  showViewHistory() {
		if (this.selectedWorkItems.length != 1) {
		  return;
		}
		const userGpid = this.globalVariable.getUserGPID;
		const systemId = this.globalVariable.getSelectedSystemId;
		const documentId = this.selectedWorkItems[0].DocumentId;
		this.retrievalService.getWorkflowHistory(userGpid, systemId, documentId)
		.subscribe({
		  next: (response: WorkflowHistoryResponse[]) => {
			this.dialog.open(WorkflowHistoryDialogComponent, {
			  width: '85%',
			  height: '485px',
			  maxWidth: '100%',
			  maxHeight: 'max-content',
			  data: response,
			});
		  },
		  error: (error: any) => {
			console.error('Failed to fetch workflow history:', error);
		  },
		});
	  }
	 
	  openUserSystemDialog(tabName: string): void {
		const dialogRef = this.dialog.open(UserReassignComponent, {
		  width: '500px',
		  height: '200px',
		  data: {
			tabfunction: tabName,
			selectedRows: this.selectedWorkItems,
			queueID: this.activeQueueIndex,
			workflowID: this.selectedAdminWorkFlowId,
		  },
		});

		dialogRef.afterClosed().subscribe((result) => {
		  this.refreshWorkItem();
		});
	  }

	  assignReleaseWorkItem(tabName: string) {
		const action = tabName == 'RELEASE' ? 'Releas' : 'Assign';
		const workItemIds: any[] = [];
		this.selectedWorkItems.forEach((item: WorkItem) => {
		  workItemIds.push(String(item.InstanceId));
		});
		const postObj = new ReAssignReleaseDto();
		postObj.systemId = Number(this.globalVariable.getSelectedSystemId);
		postObj.userGpid = this.globalVariable.getUserGPID;
		postObj.workItemId = workItemIds;
		postObj.queueId = this.activeQueueIndex;
		postObj.workFlowId = this.selectedAdminWorkFlowId;
		postObj.owningUser = '';
		postObj.assignUserGpid = tabName == 'RELEASE' ? '*' : tabName;
		this.commonService.assignReleaseWorkItemWorkFlow(postObj).subscribe({
		  next: (response) => {
			this.commonService.showMessage(action + 'ing WorkItem Completed Successfully!','success'); 
			this.refreshWorkItem();
		  },
		  error: (error) => {
			this.commonService.openErrorDialog("Error while " + action + "ing the workitem. Please retry again.");
			this.commonService.showMessage('Error while ' + action + 'ing work items.','error'); 
			console.log(action + "ing WorkItem WorkFlow Failed!" + error.error);
		  },
		});
	  }

	  activateSuspendWorkItem(tabName: string) {
		const workItemIds: any[] = [];
		this.selectedWorkItems.forEach((item: WorkItem) => {
		  if (item.StatusAsString.toLowerCase() != tabName.toLowerCase()) {
			workItemIds.push(item.InstanceId);
		  }
		});
		const workItemStatus = tabName == this.adminEmitter.Active ? this.adminEmitter.Active : this.adminEmitter.Suspend;
		const action = workItemStatus.toLowerCase() == 'active' ? 'Activat' : workItemStatus.toLowerCase();
		if (workItemIds.length >= 1) {
		  const postObj = new ActivateSuspendDto();
		  postObj.systemID = Number(this.globalVariable.getSelectedSystemId);
		  postObj.userGPID = this.globalVariable.getUserGPID;
		  postObj.workItemID = workItemIds;
		  postObj.wiStatusName = workItemStatus;
		  postObj.queueId = this.activeQueueIndex;
		  postObj.workflowID = this.selectedAdminWorkFlowId;

		  this.commonService.activateSuspendWorkItem(postObj).subscribe({
			next: (response) => {
			  this.commonService.showMessage(action + 'ing WorkItem Completed Successfully!', 'success'); 
			  this.refreshWorkItem();
			},
			error: (error) => {
			  this.commonService.openErrorDialog(error.error.message);
			  this.commonService.showMessage('Error while ' + action + 'ing work items.','error');
			},
		  });
		} else {
		  this.commonService.showMessage('The selected work Item(s) is already in ' + action + ' state','success');
		}
	  }

	  deleteWorkItem() {
		if (this.selectedWorkItems.length >= 1) {
		  const dialogData: DialogData = {
			title: 'DELETE',
			message: 'Are you sure you want to delete?',
			showOkButton: true,
			showCancelButton: true,
		  };
		  const dialogRef = this.dialog.open(DialogComponent, {
			width: '600px',
			height: '135px',
			data: dialogData,
		  });
		  dialogRef.afterClosed().subscribe((result) => {
			if (result === 'ok') {
			   const workItemIds: any[] = [];
			  this.selectedWorkItems.forEach((item: WorkItem) => {
				workItemIds.push(String(item.InstanceId));
			  });
			  const deleteWorkItemDto = new DeleteWorkItemDto();
			  deleteWorkItemDto.systemId = Number(
				this.globalVariable.getSelectedSystemId
			  );
			  deleteWorkItemDto.userGpid = this.globalVariable.getUserGPID;
			  deleteWorkItemDto.workItemId = workItemIds;
			  deleteWorkItemDto.queueId = this.activeQueueIndex;
			  deleteWorkItemDto.workflowId = this.selectedAdminWorkFlowId;

			  this.workflowService.deleteWorkItem(deleteWorkItemDto).subscribe({
				next: (response) => {
				  if (response) {
					this.commonService.showMessage('Successfully deleted.','success');
				  } else {
					this.commonService.showMessage('Error while deleting WorkItem.','error');
				  }
				  this.refreshWorkItem();
				},
				error: (error) => {
				  this.commonService.showMessage('Error deleting WorkItem -' + error.error.message,'error');
				},
			  });
			}
		  });
		}
	  }

	  openDocument(url: string, event: MouseEvent) {
		event.preventDefault();
		const tabName = 'document_tab_' + btoa(encodeURIComponent(url)); // unique per URL
		const win = window.open(url, tabName);
		if (win) {
		  win.focus();
		}
	  }

	  handleRightClick(event: MouseEvent) {
		event.preventDefault();
		this.commonService.openErrorDialog('Right click is disabled for this action. Please navigate using left mouse click.');
	  }

	  documentNotesDisable() {
		if (this.selectedWorkItems.length != 1) {
		  this.isDocumentNotesDisable = true;
		} else {
		  this.isDocumentNotesDisable = false;
		}
		return this.isDocumentNotesDisable;
	  }

	  workflowNotesDisable() {
		if (this.selectedWorkItems.length != 1) {
		  this.isWorkflowNotesDisable = true;
		} else {
		  this.isWorkflowNotesDisable = false;
		}
		return this.isWorkflowNotesDisable;
	  }

	  documentHistoryDisable() {
		if (this.selectedWorkItems.length != 1) {
		  this.isDocumentHistoryDisable = true;
		} else {
		  this.isDocumentHistoryDisable = false;
		}
		return this.isDocumentHistoryDisable;
	  }

	  workflowHistoryDisable() {
		if (this.selectedWorkItems.length != 1) {
		  this.isWorkflowHistoryDisable = true;
		} else {
		  this.isWorkflowHistoryDisable = false;
		}
		return this.isWorkflowHistoryDisable;
	  }

	  deleteDisable() {
		if (this.selectedWorkItems.length >= 1) {
		  this.isDeleteDisable = !AppContext.userDetails.canDelete;
		}
		else {
		  this.isDeleteDisable = true;
		}
		return this.isDeleteDisable;
	  }
	 
	  suspendDisable() {
		if (this.selectedWorkItems.length >= 1) {
		  this.isSuspendDisable = !AppContext.userDetails.canSuspend;
		}
		else {
		  this.isSuspendDisable = true;
		}
		return this.isSuspendDisable;
	  }

	  activateDisable() {
		if (this.selectedWorkItems.length >= 1) {
		  this.isActivateDisable = !AppContext.userDetails.canActivate;
		}
		else {
		  this.isActivateDisable = true;
		}
		return this.isActivateDisable;
	  }

	  releaseDisable() {
		const hasIberiaCustomerRebates = Object.values(
			AppContext.userDetails.userRoles
		).some(role => role.id === 46);

		if (this.selectedWorkItems.length >= 1) {
		  this.isReleaseDisable = hasIberiaCustomerRebates
			? false
			: !AppContext.userDetails.canRelease;
		}
		else {
		  this.isReleaseDisable = true;
		}
		return this.isReleaseDisable;
	  }

	  reAssignDisable() {
		if (this.selectedWorkItems.length >= 1) {
		  this.isReAssignDisable = !AppContext.userDetails.canReAssign;
		}
		else {
		  this.isReAssignDisable = true;
		}
		return this.isReAssignDisable;
	  }

	  exportToExcelDisable() {
		return this.isExportToExcelDisable;
	  }

	  refreshWorkItemDisable() {
		return this.isRefreshWorkItemDisable;
	  }

	  toggleLeftQueuePanel() {
		this.leftQueuePanelOpen = !this.leftQueuePanelOpen;
		this.isWorkStatusActive = !this.leftQueuePanelOpen ? false : true;
	  }

	  min(a: number, b: number): number {
		return Math.min(a, b);
	  }

	  applyCall(col: GridColumnHeader, filterRef: any) {
		this.selectedWorkItems = [];
		this.selectedIndexes = [];
		col.advancefilter.isAdvanceFilterUsed = true;
		this.applyAdvancedFilter(col);
		filterRef.hide();
	  }

	  applyAdvancedFilter(col: GridColumnHeader) {
		const field = col.field;
		const filterMeta = col.advancefilter;

		// Skip filtering if no constraints or filter not enabled
		if (!filterMeta?.isAdvanceFilterUsed || !filterMeta.constraints?.length) {
		  return;
		}

		const constraints = filterMeta.constraints;  
		const lastConstraint = constraints[constraints.length - 1];

		const operator = !lastConstraint || lastConstraint.value === null || lastConstraint.value === ''
		  ? 'or' : filterMeta.operator || 'or';
		this.workItems = this.workItems.filter(row => {
		  const rowValue = (row as any)[field];

		  const results = constraints.map(constraint => {
		  const filterValue = constraint.value;
		  const matchMode = constraint.matchMode;

		  // Normalize values
		  const stringValue = rowValue?.toString()?.toLowerCase?.();
		  const filterString = filterValue?.toString()?.toLowerCase?.();

			switch (matchMode) {
			  // String-based logic
			  case 'eq':
				return stringValue === filterString;
			  case 'startswith':
				return stringValue?.startsWith(filterString);
			  case 'contains':
				return stringValue?.includes(filterString);
			  case 'doesnotcontain':
				return !stringValue?.includes(filterString);
			  case 'endswith':
				return stringValue?.endsWith(filterString);

			  // Date/number logic
			  case 'gt':
				return new Date(rowValue) > new Date(filterValue);
			  case 'gte':
				return new Date(rowValue) >= new Date(filterValue);
			  case 'lt':
				return new Date(rowValue) < new Date(filterValue);
			  case 'lte':
				return new Date(rowValue) <= new Date(filterValue);

			  // Null checks
			  case 'isnull':
				return rowValue == null || rowValue === '';
			  case 'isnotnull':
				return rowValue != null && rowValue !== '';

			  default:
				return true;
			}
		  });

		  // Combine with AND/OR operator
		  return operator === 'or' ? results.some(r => r) : results.every(r => r);
		});
	  }

	  clearCall(col: GridColumnHeader, filterCallback?: any, filterRef?: any) {
		col.advancefilter.isAdvanceFilterUsed = false;
		col.advancefilter.constraints.forEach((c:ConstraintsModel) => {
		  c.value = '';
		});
		this.workItems = this.data;
		if(filterCallback && filterRef){
		  filterCallback(null);filterRef.hide();
		}
	  }

	  onDateRuleChange(event: any, field: string, index: number) {
		const value = event ? event : event.target?.value;
		const col = this.columns.find(c => c.field === field);
		if (col) {
		  col.advancefilter.constraints[index].value = value;
		}
	  }

	  onRuleChange(event: any, field: string, index: number) {
		const value = typeof event === 'string' ? event : event.target?.value;
		const col = this.columns.find(c => c.field === field);
		if (col) {
		  col.advancefilter.constraints[index].value = value;
		}
	  }

	  onMatchModeChange(event: any, field: string, index: number) {
		const mode = typeof event === 'string' ? event : event.target?.value;
		const col = this.columns.find(c => c.field === field);
		if (col) {
		  col.advancefilter.constraints[index].matchMode = mode;
		}
	  }

	  onOperatorChange(event: any, field: string) {
		const operator = typeof event === 'string' ? event : event.value;
		const col = this.columns.find(c => c.field === field);
		if (col) {
		  col.advancefilter.operator = operator;
		}
	  }
	}